// airportToCity — pure IATA airport code → city name lookup.
//
// Extracted verbatim from `AIChatBot.js` (module-level `IATA_CITY_MAP` constant
// and `airportToCity` helper) as part of the behavior-preserving refactor
// (issue #240). Given an IATA/ICAO airport code, returns the mapped U.S. city
// name, or `null` when the code is missing or unrecognized.
//
// React-free and side-effect-free. Returns `null` for falsy input and for any
// code not present in the lookup table, matching the source exactly.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

// ─── IATA airport code → city name lookup ─────────────────────────────────────
export const IATA_CITY_MAP = {
  MCO: 'Orlando', KMCO: 'Orlando',
  DFW: 'Dallas', KDFW: 'Dallas', DAL: 'Dallas', KDAL: 'Dallas',
  LAX: 'Los Angeles', KLAX: 'Los Angeles',
  JFK: 'New York', KJFK: 'New York', LGA: 'New York', KLGA: 'New York',
  EWR: 'Newark', KEWR: 'Newark',
  ORD: 'Chicago', KORD: 'Chicago', MDW: 'Chicago', KMDW: 'Chicago',
  ATL: 'Atlanta', KATL: 'Atlanta',
  MIA: 'Miami', KMIA: 'Miami', FLL: 'Fort Lauderdale', KFLL: 'Fort Lauderdale',
  TPA: 'Tampa', KTPA: 'Tampa',
  SEA: 'Seattle', KSEA: 'Seattle',
  SFO: 'San Francisco', KSFO: 'San Francisco',
  OAK: 'Oakland', KOAK: 'Oakland', SJC: 'San Jose', KSJC: 'San Jose',
  BOS: 'Boston', KBOS: 'Boston',
  DEN: 'Denver', KDEN: 'Denver',
  IAH: 'Houston', KIAH: 'Houston', HOU: 'Houston', KHOU: 'Houston',
  LAS: 'Las Vegas', KLAS: 'Las Vegas',
  PHX: 'Phoenix', KPHX: 'Phoenix',
  CLT: 'Charlotte', KCLT: 'Charlotte',
  DTW: 'Detroit', KDTW: 'Detroit',
  MSP: 'Minneapolis', KMSP: 'Minneapolis',
  PHL: 'Philadelphia', KPHL: 'Philadelphia',
  DCA: 'Washington DC', KDCA: 'Washington DC',
  IAD: 'Washington DC', KIAD: 'Washington DC',
  SAN: 'San Diego', KSAN: 'San Diego',
  STL: 'St. Louis', KSTL: 'St. Louis',
  BNA: 'Nashville', KBNA: 'Nashville',
  AUS: 'Austin', KAUS: 'Austin',
  PDX: 'Portland', KPDX: 'Portland',
  SLC: 'Salt Lake City', KSLC: 'Salt Lake City',
  MCI: 'Kansas City', KMCI: 'Kansas City',
  RDU: 'Raleigh', KRDU: 'Raleigh',
  IND: 'Indianapolis', KIND: 'Indianapolis',
  MSY: 'New Orleans', KMSY: 'New Orleans',
  JAX: 'Jacksonville', KJAX: 'Jacksonville',
  SAT: 'San Antonio', KSAT: 'San Antonio',
  HNL: 'Honolulu', PHNL: 'Honolulu',
  ANC: 'Anchorage', PANC: 'Anchorage',
  RSW: 'Fort Myers', KRSW: 'Fort Myers',
  PBI: 'West Palm Beach', KPBI: 'West Palm Beach',
  CMH: 'Columbus', KCMH: 'Columbus',
  CLE: 'Cleveland', KCLE: 'Cleveland',
  PIT: 'Pittsburgh', KPIT: 'Pittsburgh',
  OKC: 'Oklahoma City', KOKC: 'Oklahoma City',
  MEM: 'Memphis', KMEM: 'Memphis',
  BUF: 'Buffalo', KBUF: 'Buffalo',
};

/**
 * Maps an airport code to a U.S. city name.
 *
 * @param {string|null|undefined} code - IATA/ICAO airport code (case-insensitive).
 * @returns {string|null} The mapped city name, or `null` when missing/unknown.
 */
export function airportToCity(code) {
  if (!code) return null;
  return IATA_CITY_MAP[code.toUpperCase()] || null;
}

export default airportToCity;
